import React, { useState, useEffect } from 'react';
import { Grid, Stack, Avatar, IconButton, Typography, Button, Paper, Card, Box, CardContent, Popper, CardMedia } from '@mui/material';
import { ExpandMore, Adb, ExpandLess, ChevronLeft, ChevronRight } from '@mui/icons-material';
import { makeStyles } from '@mui/styles';
import Carousel from 'react-multi-carousel';
import SubCardCollapase from 'ui-component/cards/SubCardCollapase';
import moment from 'moment';
import 'moment/locale/es';
import 'react-multi-carousel/lib/styles.css';
import { width } from '@mui/system';

const useStyle = makeStyles((theme) => ({
    principal: {
        position: 'relative',
        width: '100%'
    },
    boton: {
        position: 'fixed',
        right: '30px',
        bottom: '10px'
    },
    root: {
        minWidth: '100%',
        backgroundColor: '#E0E0E0',
        marginRight: '20px',
        '&:hover': {
            cursor: 'pointer'
        }
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)'
    },
    title: {
        fontSize: 14
    },
    pos: {
        marginBottom: 12
    },
    btnCancelar: {
        color: theme.palette.btn.red,
        '&:hover': {
            backgroundColor: theme.palette.btn.red,
            color: theme.palette.btn.white
        }
    }
}));

const Tarjeta = (props) => {
    const { curso, selectCurso } = props;
    const classes = useStyle();
    const eligeCurso = () => {
        selectCurso(curso);
    };

    const getTitulo = (item) => {
        if (item.idCurso) {
            if (item.tipoGrupo == 2) {
                //si el grupo es de administrativo(2) se bloquea cuando ya pase su tiempo de acceso
                let hoy = moment();
                let fechaInicio = moment(item.fechaInicio);
                let fechaFin = moment(item.fechaFin);
                if (hoy >= fechaInicio && hoy <= fechaFin) {
                    return item.isAprobado == 1 ? 'Curso completado' : 'Curso disponible';
                } else {
                    return 'Curso finalizado';
                }
            } else {
                return item.isAprobado == 1 ? 'Curso completado' : 'Curso disponible';
            }
        } else {
            return 'Anuncio';
        }
    };

    const getTexto = (item) => {
        if (item.idCurso) {
            return item.titulo;
        } else {
            return item.anuncio;
        }
    };
    return (
        <Card className={classes.root} variant="outlined" onClick={eligeCurso}>
            <CardMedia
                component="img"
                // sx={{ objectFit: 'contain' }}
                height="360"
                image={
                    curso?.portadaCursoMostrar != null
                        ? curso?.portadaCursoMostrar
                        : 'https://cdn.pixabay.com/photo/2012/12/14/04/41/e-mail-69911_960_720.jpg'
                }
                alt="portada"
            />
            <CardContent>
                <Typography className={classes.title} color="textSecondary" gutterBottom>
                    {getTitulo(curso)}
                </Typography>
                <Typography variant="h5" component="h2">
                    {getTexto(curso)}
                </Typography>
                {curso.Descripcion && (
                    <Typography variant="body2" component="p">
                        {curso.Descripcion}
                    </Typography>
                )}
            </CardContent>
        </Card>
    );
};

const ItemCarousel = (props) => {
    const { cursos, selectCurso } = props;
    const classes = useStyle();

    const [listaCursos, setListaCursos] = useState([]);

    useEffect(() => {
        if (cursos && cursos.length > 0) {
            let nuevaLista = [];
            cursos.forEach((el) => {
                if (el.idCurso) {
                    nuevaLista.push(el);
                } else {
                    const hoy = moment();
                    let inicio = null;
                    if (el.periodo && el.periodo == 'ANUAL') {
                        let actual = new Date();
                        let year = actual.getFullYear();
                        let arr = el.inicio.split('-');

                        inicio = moment(year, arr[1], arr[2]);
                    } else {
                        inicio = moment(el.inicio);
                    }

                    if (el.fin != 'NO') {
                        const fin = moment(el.fin);
                        if (hoy >= inicio && hoy <= fin) {
                            nuevaLista.push(el);
                        }
                    } else {
                        if (inicio <= hoy) {
                            nuevaLista.push(el);
                        }
                    }
                }
            });

            setListaCursos([...nuevaLista]);
        }
    }, [cursos]);
    return (
        <div style={{ width: '100%', padding: '20px' }}>
            <Carousel
                additionalTransfrom={0}
                arrows
                autoPlay
                autoPlaySpeed={6000}
                centerMode={false}
                className={classes.carrusel}
                containerClass="container"
                dotListClass=""
                draggable
                focusOnSelect={false}
                infinite
                itemClass=""
                keyBoardControl
                minimumTouchDrag={80}
                pauseOnHover
                renderArrowsWhenDisabled={false}
                renderButtonGroupOutside={false}
                renderDotsOutside={false}
                responsive={{
                    desktop: {
                        breakpoint: {
                            max: 3000,
                            min: 1024
                        },
                        items: 1
                    },
                    mobile: {
                        breakpoint: {
                            max: 464,
                            min: 0
                        },
                        items: 1
                    },
                    tablet: {
                        breakpoint: {
                            max: 1024,
                            min: 464
                        },
                        items: 1
                    }
                }}
                rewind={false}
                rewindWithAnimation={false}
                rtl={false}
                shouldResetAutoplay
                showDots
                sliderClass=""
                slidesToSlide={1}
                swipeable
            >
                {listaCursos?.map((curso, index) => (
                    <Tarjeta key={`cur${index}`} curso={curso} selectCurso={selectCurso} />
                ))}
            </Carousel>
        </div>
    );
};

export default ItemCarousel;
